import {PureComponent} from 'react';
import Switch from 'react-switch';
import {connect} from 'react-redux';
import {disableProdSwitcher, enableProdSwitcher} from '../redux/prodswitcher/prodSwitcherActions';
import {showSuccess} from '../elements/Toasts/toastActions';
import strings from "../lang/lang";

const mapStateToProps = (state) => ({
    isProdSwitcherOpen: state.prodSwitcher.isProdSwitcherOpen,
});

const mapDispatchToProps = {};

class ProdSwitcher extends PureComponent {

    handleChange = () => {
        if (this.props.isProdSwitcherOpen) {
            return (
                showSuccess(strings.liveMode.text.sandboxMode),
                    disableProdSwitcher()
            );
        } else {
            return (
                showSuccess(strings.liveMode.text.prodMode),
                    enableProdSwitcher()
            );
        }
    };

    render() {
        const {handleDiameter, height, width, isProdSwitcherOpen} = this.props;

        return (
            <>
                <label>
                    <Switch
                        checked={isProdSwitcherOpen}
                        onChange={this.handleChange}
                        onColor="#4B4D5B"
                        onHandleColor="#F85B7A"
                        offColor="#D2D3D6"
                        offHandleColor="#F85B7A"
                        handleDiameter={handleDiameter}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        height={height}
                        width={width}
                    />
                </label>
            </>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProdSwitcher);
